import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

function ProtectedRoute({ children }) {
  //   const authenticated = useSelector((state) => state.auth.status);
  const user = useSelector((state) => state.auth.user?.$id);
  const loading = useSelector((state) => state.auth.loading);
  const location = useLocation();

  const initialized = useSelector((state) => state.auth.initialized);

  if (!initialized) {
    return <div>Loading session...</div>; // Or a spinner
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
